export const DEPARTMENT_MAP = {
  "1": "sales",
  "2,3": "service",
  "6": "customerService",
  "7": "marketing",
  "4,5,8": "others",
};

export const PKD_MAP = {
  "indicators-department": DEPARTMENT_MAP,
  "checklists-department": DEPARTMENT_MAP,
};
